export default __webpack_public_path__ + "4c47a48262d3670c6bf7c82ccfcc1c1a.png";